__turbopack_context__.v({
  "carousel": "ChordGraphFrame-module__M6z9AW__carousel",
  "chromeScope": "ChordGraphFrame-module__M6z9AW__chromeScope",
  "controlsStack": "ChordGraphFrame-module__M6z9AW__controlsStack",
  "datazoneLink": "ChordGraphFrame-module__M6z9AW__datazoneLink",
  "desktopFilters": "ChordGraphFrame-module__M6z9AW__desktopFilters",
  "filterGroup": "ChordGraphFrame-module__M6z9AW__filterGroup",
  "filterHeading": "ChordGraphFrame-module__M6z9AW__filterHeading",
  "filterLabel": "ChordGraphFrame-module__M6z9AW__filterLabel",
  "filterList": "ChordGraphFrame-module__M6z9AW__filterList",
  "filterTab": "ChordGraphFrame-module__M6z9AW__filterTab",
  "filterTabActive": "ChordGraphFrame-module__M6z9AW__filterTabActive",
  "filters": "ChordGraphFrame-module__M6z9AW__filters",
  "legend": "ChordGraphFrame-module__M6z9AW__legend",
  "legendHeading": "ChordGraphFrame-module__M6z9AW__legendHeading",
  "legendItem": "ChordGraphFrame-module__M6z9AW__legendItem",
  "legendList": "ChordGraphFrame-module__M6z9AW__legendList",
  "legendListInactive": "ChordGraphFrame-module__M6z9AW__legendListInactive",
  "legendLists": "ChordGraphFrame-module__M6z9AW__legendLists",
  "mapColumn": "ChordGraphFrame-module__M6z9AW__mapColumn",
  "mapPlate": "ChordGraphFrame-module__M6z9AW__mapPlate",
  "root": "ChordGraphFrame-module__M6z9AW__root",
  "statContent": "ChordGraphFrame-module__M6z9AW__statContent",
  "statCountry": "ChordGraphFrame-module__M6z9AW__statCountry",
  "statDescription": "ChordGraphFrame-module__M6z9AW__statDescription",
  "statDisc": "ChordGraphFrame-module__M6z9AW__statDisc",
  "statRing": "ChordGraphFrame-module__M6z9AW__statRing",
  "stats": "ChordGraphFrame-module__M6z9AW__stats",
  "swatch": "ChordGraphFrame-module__M6z9AW__swatch",
  "toggleActive": "ChordGraphFrame-module__M6z9AW__toggleActive",
  "toggleInactive": "ChordGraphFrame-module__M6z9AW__toggleInactive",
  "toggleRow": "ChordGraphFrame-module__M6z9AW__toggleRow",
});
